import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import InvoicesSection from "./sections/InvoicesSection";
import InvoiceDetail from "./pages/InvoiceDetail";
import BillingDetail from "features/billings/pages/BillingDetail";

const Invoices = () => {
  const { t } = useTranslation("shared\\moduleNames");
  const match = useRouteMatch();

  return (
    <Switch>
      <Route
        path={`${match.path}/:invoiceId/billing/:billingId`}
        component={BillingDetail}
      />
      <Route path={`${match.path}/:invoiceId`}>
        <InvoiceDetail
          type="Invoice"
          backPage={{ text: t("invoices.title"), to: match.path }}
        />
      </Route>
      <Route path={match.path}>
        <Header title={t("invoices.title")} includeBreadcrumbs />
        <ModuleContent>
          <InvoicesSection />
        </ModuleContent>
      </Route>
    </Switch>
  );
};

export default Invoices;
